/**
 * The AI arranger's switch: how far trained models take part, off until it is turned on.
 *
 * The AI arranger is kept apart from the rules arranger's choices beside it. It never touches
 * the source's notes: it hands the rules a plan of who rests, who holds and who walks the chord,
 * among the notes the arranger writes that the source does not have, and at Normal who waiting
 * is given a note of the chord.
 */

import { AI_LEVELS, type AiLevel } from "@app/shared-types";
import ArrangeMenu, { type Named } from "./ArrangeMenu";

/** Each level as the menu names it. Keyed by level so a new one cannot go unnamed. */
export const AI_NAMES: Named<AiLevel> = {
  off: {
    label: "Off",
    title: "The rules arrange alone, as every other choice here says.",
  },
  light: {
    label: "Light",
    title:
      "Trained models say which player walks each chord the harmony adds and which holds it, where Broken or Alberti would have one player walk it, and walk a Held chord where they set a player moving. Nothing is left out. The source's own notes are not touched, and the hands of a piano, a harp, an organ or a celesta are left to the rules.",
  },
  normal: {
    label: "Normal",
    title:
      "As Light, and trained models also say who plays at all, as a composer would: a player resting leaves out the notes the harmony added to it or it plays doubling a line, for as long as it rests, and a player not resting whom the rules leave waiting is given a note of the chord. The source's own notes are never changed, and the hands of a piano, a harp, an organ or a celesta are left to the rules.",
  },
};

export default function AiArrangerMenu({
  value,
  shut,
  onPick,
}: {
  readonly value: AiLevel;
  /** Why the menu is shut, where it is. */
  readonly shut?: string;
  onPick(value: AiLevel): void;
}): JSX.Element {
  return (
    <ArrangeMenu
      label="AI arranger"
      value={value}
      values={AI_LEVELS}
      names={AI_NAMES}
      shut={shut}
      onPick={onPick}
    />
  );
}
